import BlujayGsoftIndex from "@/components/blujay/gsoft/BlujayGsoftIndex.vue";
import BlujayGsoftDetail from "@/components/blujay/gsoft/BlujayGsoftDetail.vue";

let routesBlujayGsoftAccess= [
    {
        path: '',
        meta: {
          title: "List Blujay Gsoft",
        },
        name: "BlujayGsoftIndex",
        component: BlujayGsoftIndex
    }, 
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Blujay Gsoft",
        },
        name: "BlujayGsoftDetail",
        component: BlujayGsoftDetail
    },
     
    
]

export default routesBlujayGsoftAccess
  